import React from 'react';
import { useI18nContext } from '@ecg-marktplaats/js-react-i18n';
import { Icon, StarRating } from '@hz-design-system/web-ui';

import { TReviewDetail } from 'types/UserReviews';

import Classes from './UserReviewsListItem.scss';

type AggregatedCharacteristics = {
  positiveCharacteristics: string[];
  negativeCharacteristics: string[];
};

type TUserReviewsListItemProps = {
  review: TReviewDetail;
};

const UserReviewsListItem = ({ review }: TUserReviewsListItemProps) => {
  const { date } = useI18nContext();

  const reviewDate = date(new Date(review.creationDate), 'd MMM `yy');

  const { positiveCharacteristics, negativeCharacteristics } = review.characteristics.reduce<AggregatedCharacteristics>(
    (mappedCharacteristics, characteristic) => {
      if (characteristic.isPositive) {
        mappedCharacteristics.positiveCharacteristics.push(characteristic.text);
        return mappedCharacteristics;
      }

      mappedCharacteristics.negativeCharacteristics.push(characteristic.text);
      return mappedCharacteristics;
    },
    {
      positiveCharacteristics: [],
      negativeCharacteristics: [],
    },
  );
  const positiveCharacteristicsText = positiveCharacteristics.join(' · ');
  const negativeCharacteristicsText = negativeCharacteristics.join(' · ');

  return (
    <li className={Classes.root}>
      <div className={Classes.header}>
        <h6>{review.reviewer.nickname}</h6>
        <p>{reviewDate}</p>
      </div>
      <p>{review.advertisement.categoryName}</p>
      <StarRating rating={review.score} />

      <div className={Classes.reviewContent}>
        {!!positiveCharacteristicsText && (
          <div className={Classes.reviewContentItem}>
            <Icon name="thumbsup" />
            {positiveCharacteristicsText}
          </div>
        )}
        {!!negativeCharacteristicsText && (
          <div className={Classes.reviewContentItem}>
            <Icon name="thumbsdown" />
            <span>{negativeCharacteristicsText}</span>
          </div>
        )}
      </div>
    </li>
  );
};

export default UserReviewsListItem;
